import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SOJI_USER } from '../constants';
import { IAuth, IUser } from './interface';

const initialState: IAuth = { rememberUser: false, user: null };
export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<IUser | null>) => {
      state.user = action.payload;
      localStorage.setItem(SOJI_USER, JSON.stringify(state));
    },
    setRemeberUser: (state, action: PayloadAction<boolean>) => {
      state.rememberUser = action.payload;
      localStorage.setItem(SOJI_USER, JSON.stringify(state));
    }
  }
});

export const { setUser, setRemeberUser } = authSlice.actions;
